import {create} from 'zustand'
import {createTheme} from '@mui/material';
import {FactureeTheme} from '../FactureeComponents/FactureeTheme';
import StorageHelper from "../helpers/storageHelper";

interface ThemeStore {
    theme: 'dark' | 'light',
    materialTheme: any
    toggleDarkMode: () => void
}

export const useThemeStore = create<ThemeStore>()((set, get) => ({
    theme: StorageHelper.getTheme() as ('dark' | 'light'),
    materialTheme: createTheme(FactureeTheme(StorageHelper.getTheme())),
    toggleDarkMode: () => {
        let newTheme: 'dark' | 'light' = get().theme === 'dark' ? 'light' : 'dark';
        StorageHelper.setTheme(newTheme);
        set({theme: newTheme, materialTheme: createTheme(FactureeTheme(newTheme))})
    },
}))
